module.exports = __webpack_public_path__ + "static/flags/NL-3baf2704a1c2b5411259d8cb0809006d.gif";